/**
 * Card Vault Browser — companion to Comic Archive.
 * Views: all (products) | sports (collections) | nonsports (products|franchises) | lookup
 */
(function () {
  var VALID_VIEWS = { all: 1, sports: 1, nonsports: 1, lookup: 1 };
  var BROWSE_VIEWS = { all: 1, sports: 1, nonsports: 1 };
  var PRODUCT_VIEWS = { all: 1, nonsports: 1 };
  var GRID_SECTION = 'mc-card-vault-grid';
  var lookupCache = Object.create(null);
  var viewCache = Object.create(null);

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function getParams() {
    try {
      return new URL(window.location.href).searchParams;
    } catch (e) {
      return new URLSearchParams();
    }
  }

  function readView(root) {
    // Prefer `vault=` — Shopify reserves `view=` for alternate templates (e.g. card-vault).
    var fromUrl = (getParams().get('vault') || getParams().get('view') || '').toLowerCase();
    if (VALID_VIEWS[fromUrl]) return fromUrl;
    return root.getAttribute('data-cab-default-view') || 'all';
  }

  function writeUrl(state, mode) {
    try {
      var url = new URL(window.location.href);
      Object.keys(state).forEach(function (key) {
        var value = state[key];
        // Migrate legacy `view=all|sports|…` onto the vault param.
        if (key === 'view' && VALID_VIEWS[String(value || '').toLowerCase()]) {
          key = 'vault';
        }
        if (value === null || value === undefined || value === '') {
          url.searchParams.delete(key);
        } else {
          url.searchParams.set(key, value);
        }
      });
      // Shopify `view=` selects alternate templates — always keep card-vault here.
      var viewParam = (url.searchParams.get('view') || '').toLowerCase();
      if (!viewParam || VALID_VIEWS[viewParam]) {
        url.searchParams.set('view', 'card-vault');
      }
      if (mode === 'push') history.pushState(state, '', url);
      else history.replaceState(state, '', url);
    } catch (e) {
      /* ignore */
    }
  }

  function announce(root, message) {
    var el = root.querySelector('[data-cab-announcer]');
    if (!el) return;
    el.textContent = '';
    window.setTimeout(function () {
      el.textContent = message || '';
    }, 20);
  }

  function moveIndicator(root) {
    var track = root.querySelector('[data-cab-tablist]');
    var indicator = root.querySelector('[data-cab-indicator]');
    var active = root.querySelector('[data-cab-tab].is-active');
    if (!track || !indicator || !active) return;
    var trackRect = track.getBoundingClientRect();
    var tabRect = active.getBoundingClientRect();
    indicator.style.width = tabRect.width + 'px';
    indicator.style.transform =
      'translateX(' + (tabRect.left - trackRect.left + track.scrollLeft) + 'px)';
    indicator.style.opacity = '1';
  }

  function scrollActiveTabIntoView(root) {
    var active = root.querySelector('[data-cab-tab].is-active');
    if (!active || typeof active.scrollIntoView !== 'function') return;
    active.scrollIntoView({
      behavior: prefersReducedMotion() ? 'auto' : 'smooth',
      inline: 'center',
      block: 'nearest'
    });
  }

  function updateScrollHint(root) {
    var wrap = root.querySelector('.cab-selector__track-wrap');
    var track = root.querySelector('[data-cab-tablist]');
    if (!wrap || !track) return;
    wrap.classList.toggle('is-scrollable', track.scrollWidth > track.clientWidth + 4);
  }

  function setTabState(root, view) {
    root.querySelectorAll('[data-cab-tab]').forEach(function (tab) {
      var isActive = tab.getAttribute('data-cab-view') === view;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.tabIndex = isActive ? 0 : -1;
      var selectedText = tab.querySelector('.cab-selector__selected-text');
      if (selectedText) selectedText.hidden = !isActive;
    });
    moveIndicator(root);
    scrollActiveTabIntoView(root);
  }

  function reinitLazyload(scope) {
    if (window.lazySizes && window.lazySizes.loader) {
      try {
        window.lazySizes.loader.checkElems();
      } catch (e) {
        /* ignore */
      }
    }
    if (window.theme && typeof window.theme.productCardImageLoadingAnimation === 'function') {
      try {
        window.theme.productCardImageLoadingAnimation();
      } catch (e) {
        /* ignore */
      }
    }
  }

  function applyShelf(root, view) {
    var shelf = BROWSE_VIEWS[view] ? view : 'all';
    var shelves = root.querySelector('[data-cv-shelves]');
    if (shelves) shelves.setAttribute('data-cv-active-shelf', shelf);

    root.querySelectorAll('[data-cv-shelf]').forEach(function (el) {
      el.hidden = el.getAttribute('data-cv-shelf') !== shelf;
    });

    var browsePanel = root.querySelector('[data-cab-browse-panel]');
    if (browsePanel) {
      browsePanel.setAttribute(
        'aria-labelledby',
        'CvTab-' + (root.getAttribute('data-section-id') || '') + '-' + shelf
      );
    }
  }

  function showLoading(host, show) {
    var loading = host.querySelector('[data-cab-loading]');
    if (!loading) {
      if (show) {
        host.innerHTML =
          '<div class="cab-loading" data-cab-loading><p class="cab-loading__text">Opening the vault</p><div class="cab-loading__bar" aria-hidden="true"></div></div>';
      }
      return;
    }
    loading.hidden = !show;
  }

  function extractRemoteGrid(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var remote = doc.querySelector('[data-cab-remote-grid]');
    if (remote) return remote.innerHTML;
    var grid = doc.querySelector('[data-cab-grid]');
    return grid ? grid.outerHTML : '';
  }

  function extractLookupPanel(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var panel = doc.querySelector('[data-cab-panel][data-cab-view="lookup"] [data-cab-panel-inner]');
    return panel ? panel.innerHTML : '';
  }

  function bindGridControls(root, shelfEl, view) {
    var sort = shelfEl.querySelector('[data-cab-sort]');
    var pagination = shelfEl.querySelector('[data-cab-pagination]');

    if (sort && !sort._cvBound) {
      sort._cvBound = true;
      sort.addEventListener('change', function () {
        loadGrid(root, view, { sort_by: sort.value, page: 1, history: 'push' });
      });
    }

    if (pagination && !pagination._cvBound) {
      pagination._cvBound = true;
      pagination.addEventListener('click', function (event) {
        var link = event.target.closest('[data-cab-page]');
        if (!link) return;
        event.preventDefault();
        var sortEl = shelfEl.querySelector('[data-cab-sort]');
        loadGrid(root, view, {
          page: link.getAttribute('data-cab-page'),
          sort_by: sortEl ? sortEl.value : undefined,
          history: 'push'
        });
      });
    }
  }

  function loadGrid(root, view, options) {
    options = options || {};
    if (!PRODUCT_VIEWS[view]) return Promise.resolve();

    var shelfEl = root.querySelector('[data-cv-shelf="' + view + '"]');
    if (!shelfEl) return Promise.resolve();

    var mode = shelfEl.getAttribute('data-cv-shelf-mode') || 'products';
    if (mode !== 'products') return Promise.resolve();

    var collectionUrl = shelfEl.getAttribute('data-cv-collection-url') || '';
    if (!collectionUrl) {
      if (!shelfEl.querySelector('[data-cab-grid], .cab-empty')) {
        shelfEl.innerHTML =
          '<div class="cab-empty" role="status"><p class="cab-empty__text">This vault section is currently being catalogued.</p></div>';
      }
      return Promise.resolve();
    }

    if (shelfEl.querySelector('[data-cab-grid]') && !options.force && !options.sort_by && !options.page) {
      bindGridControls(root, shelfEl, view);
      return Promise.resolve();
    }

    var sortBy = options.sort_by;
    if (sortBy === undefined) sortBy = getParams().get('sort_by') || '';
    var page = options.page || 1;
    var cacheKey = collectionUrl + '|v=' + view + '|s=' + sortBy + '|p=' + page;

    if (viewCache[cacheKey] && !options.force) {
      shelfEl.innerHTML = viewCache[cacheKey];
      bindGridControls(root, shelfEl, view);
      reinitLazyload(shelfEl);
      return Promise.resolve();
    }

    if (root._cvGridAbort) root._cvGridAbort.abort();
    var controller = new AbortController();
    root._cvGridAbort = controller;

    var host = shelfEl.querySelector('[data-cv-lazy-grid]') || shelfEl;
    showLoading(host, true);

    var fetchUrl = new URL(collectionUrl, window.location.origin);
    fetchUrl.searchParams.set('section_id', GRID_SECTION);
    fetchUrl.searchParams.set('view', 'card-vault');
    fetchUrl.searchParams.set('vault', view);
    if (sortBy) fetchUrl.searchParams.set('sort_by', sortBy);
    if (page && String(page) !== '1') fetchUrl.searchParams.set('page', String(page));

    return fetch(fetchUrl.toString(), {
      signal: controller.signal,
      credentials: 'same-origin',
      headers: { Accept: 'text/html' }
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Grid request failed');
        return res.text();
      })
      .then(function (html) {
        var markup = extractRemoteGrid(html);
        if (!markup) throw new Error('Empty grid');
        viewCache[cacheKey] = markup;
        shelfEl.innerHTML = markup;
        shelfEl.setAttribute('data-cv-collection-url', collectionUrl);
        bindGridControls(root, shelfEl, view);
        reinitLazyload(shelfEl);
        if (options.history) {
          writeUrl(
            {
              vault: view,
              page: page && String(page) !== '1' ? String(page) : null,
              sort_by: sortBy || null,
              q: null,
              letter: null
            },
            options.history
          );
        }
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        shelfEl.innerHTML =
          '<div class="cab-empty" role="status"><p class="cab-empty__text">This vault section is currently being catalogued.</p></div>';
      })
      .then(function () {
        if (root._cvGridAbort === controller) root._cvGridAbort = null;
      });
  }

  function ensureProductShelf(root, view) {
    applyShelf(root, view);
    if (!PRODUCT_VIEWS[view]) return Promise.resolve();
    var shelfEl = root.querySelector('[data-cv-shelf="' + view + '"]');
    if (!shelfEl) return Promise.resolve();
    if (shelfEl.getAttribute('data-cv-shelf-mode') !== 'products') return Promise.resolve();
    if (shelfEl.querySelector('[data-cab-grid]')) {
      bindGridControls(root, shelfEl, view);
      return Promise.resolve();
    }
    return loadGrid(root, view, { history: false, force: true });
  }

  var CATEGORY_SECTION = 'mc-card-vault-category-products';
  var categoryCache = Object.create(null);
  var azCatalogCache = Object.create(null);

  function letterFromTitle(title) {
    var ch = String(title || '')
      .trim()
      .charAt(0)
      .toUpperCase();
    if (ch >= 'A' && ch <= 'Z') return ch;
    return '#';
  }

  function displayCardTitle(title) {
    var raw = String(title || '').trim();
    if (!raw) return 'Card';
    if (raw.indexOf('#') !== -1) {
      raw = raw.split('#')[0].trim() || raw;
    }
    if (raw.indexOf('(') !== -1) {
      var yearPart = raw.split('(').pop().split(')')[0].trim();
      if (/^\d{4}$/.test(yearPart)) {
        raw = raw.split('(')[0].trim() || raw;
      }
    }
    return raw || title;
  }

  function productImageUrl(product) {
    if (!product) return '';
    var image = product.featured_image || (product.images && product.images[0]);
    if (!image) return '';
    if (typeof image === 'string') {
      return image.indexOf('//') === 0 ? 'https:' + image : image;
    }
    var src = image.src || image;
    if (!src) return '';
    return String(src).indexOf('//') === 0 ? 'https:' + src : src;
  }

  function productUrl(product) {
    if (!product) return '#';
    if (product.url) return product.url;
    if (product.handle) return '/products/' + product.handle;
    return '#';
  }

  function extractCategoryProducts(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var section =
      doc.querySelector('[data-cv-category-products]') ||
      doc.querySelector('[data-series-products]') ||
      doc.querySelector('.shopify-section') ||
      doc.body;
    return section ? section.innerHTML : '';
  }

  function setPanelStatus(panel, message, kind) {
    var status = panel.querySelector('[data-archive-panel-status]');
    if (!status) return;
    if (!message) {
      status.hidden = true;
      status.textContent = '';
      status.className = 'mc-comic-archive__az-panel-status';
      return;
    }
    status.hidden = false;
    status.textContent = message;
    status.className =
      'mc-comic-archive__az-panel-status' +
      (kind ? ' mc-comic-archive__az-panel-status--' + kind : '');
    status.setAttribute('role', kind === 'error' ? 'alert' : 'status');
  }

  function bindCategoryLoadMore(lookupRoot, item, content) {
    var next = content.querySelector('[data-cv-category-next]');
    if (!next || next._cvBound) return;
    next._cvBound = true;
    next.addEventListener('click', function (event) {
      event.preventDefault();
      var handle = item.getAttribute('data-series-handle');
      var page = next.getAttribute('data-cv-category-page') || '2';
      var sectionId =
        lookupRoot.getAttribute('data-cv-category-section') || CATEGORY_SECTION;
      next.setAttribute('aria-busy', 'true');
      next.textContent = 'Loading…';
      var url =
        '/collections/' +
        encodeURIComponent(handle) +
        '?section_id=' +
        encodeURIComponent(sectionId) +
        '&view=card-vault&page=' +
        encodeURIComponent(page);
      fetch(url, { credentials: 'same-origin', headers: { Accept: 'text/html' } })
        .then(function (res) {
          if (!res.ok) throw new Error('Load more failed');
          return res.text();
        })
        .then(function (html) {
          var markup = extractCategoryProducts(html);
          var temp = document.createElement('div');
          temp.innerHTML = markup;
          var grid = content.querySelector('[data-cv-category-grid]');
          var incoming = temp.querySelector('[data-cv-category-grid]');
          if (grid && incoming) {
            while (incoming.firstChild) grid.appendChild(incoming.firstChild);
          }
          var nextLink = temp.querySelector('[data-cv-category-next]');
          var actions = content.querySelector('.mc-archive-series-products__actions');
          var countEl = content.querySelector('[data-cv-category-shown]');
          var newCount = temp.querySelector('[data-cv-category-shown]');
          if (countEl && newCount) countEl.textContent = newCount.textContent;
          if (nextLink && actions) {
            next.setAttribute('data-cv-category-page', nextLink.getAttribute('data-cv-category-page'));
            next.setAttribute('href', nextLink.getAttribute('href'));
            next.textContent = 'Load more cards';
            next.removeAttribute('aria-busy');
            next._cvBound = false;
            bindCategoryLoadMore(lookupRoot, item, content);
          } else if (next.parentNode) {
            next.parentNode.removeChild(next);
          }
          reinitLazyload(content);
        })
        .catch(function () {
          next.textContent = 'Load more cards';
          next.removeAttribute('aria-busy');
        });
    });
  }

  function loadCategoryProducts(lookupRoot, item) {
    var handle = item.getAttribute('data-series-handle');
    var panel = item.querySelector('[data-archive-panel]');
    var content = panel && panel.querySelector('[data-archive-panel-content]');
    if (!handle || !panel || !content) return Promise.resolve();

    if (categoryCache[handle]) {
      content.innerHTML = categoryCache[handle];
      setPanelStatus(panel, '');
      bindCategoryLoadMore(lookupRoot, item, content);
      reinitLazyload(content);
      return Promise.resolve();
    }

    if (lookupRoot._cvCategoryAbort) lookupRoot._cvCategoryAbort.abort();
    var controller = new AbortController();
    lookupRoot._cvCategoryAbort = controller;

    setPanelStatus(panel, 'Loading cards…', 'loading');
    content.innerHTML =
      '<div class="mc-comic-archive__az-panel-skeleton" aria-hidden="true"></div>';

    var sectionId =
      lookupRoot.getAttribute('data-cv-category-section') || CATEGORY_SECTION;
    var url =
      '/collections/' +
      encodeURIComponent(handle) +
      '?section_id=' +
      encodeURIComponent(sectionId) +
      '&view=card-vault';

    return fetch(url, {
      signal: controller.signal,
      credentials: 'same-origin',
      headers: { Accept: 'text/html' }
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Failed to load category');
        return res.text();
      })
      .then(function (html) {
        var markup = extractCategoryProducts(html);
        if (!markup || !markup.trim()) throw new Error('Empty category response');
        categoryCache[handle] = markup;
        content.innerHTML = markup;
        setPanelStatus(panel, '');
        bindCategoryLoadMore(lookupRoot, item, content);
        reinitLazyload(content);
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        content.innerHTML = '';
        setPanelStatus(panel, 'Unable to load these cards. ', 'error');
        var retry = document.createElement('button');
        retry.type = 'button';
        retry.className = 'mc-comic-archive__az-retry';
        retry.textContent = 'Try again';
        retry.addEventListener('click', function () {
          delete categoryCache[handle];
          loadCategoryProducts(lookupRoot, item);
        });
        var status = panel.querySelector('[data-archive-panel-status]');
        if (status) status.appendChild(retry);
        var fallback = document.createElement('a');
        fallback.href = item.getAttribute('data-series-url') || '#';
        fallback.className = 'mc-comic-archive__az-panel-fallback-link';
        fallback.textContent = 'View full collection';
        content.appendChild(fallback);
      })
      .then(function () {
        if (lookupRoot._cvCategoryAbort === controller) {
          lookupRoot._cvCategoryAbort = null;
        }
      });
  }

  function initCategoryExpand(lookupRoot) {
    if (!lookupRoot || lookupRoot._cvCategoryBound) return;
    lookupRoot._cvCategoryBound = true;

    var items = Array.prototype.slice.call(
      lookupRoot.querySelectorAll('[data-cv-category-item]')
    );
    var openItem = null;

    items.forEach(function (item) {
      var fallback = item.querySelector('.mc-comic-archive__az-link--fallback');
      var trigger = item.querySelector('.mc-comic-archive__az-trigger');
      var panel = item.querySelector('[data-archive-panel]');
      if (!trigger || !panel) return;

      if (fallback) fallback.hidden = true;
      trigger.hidden = false;

      trigger.addEventListener('click', function () {
        var isOpen = trigger.getAttribute('aria-expanded') === 'true';
        if (isOpen) {
          trigger.setAttribute('aria-expanded', 'false');
          panel.hidden = true;
          item.classList.remove('is-open');
          if (openItem === item) openItem = null;
          return;
        }
        if (openItem && openItem !== item) {
          var prevTrigger = openItem.querySelector('.mc-comic-archive__az-trigger');
          var prevPanel = openItem.querySelector('[data-archive-panel]');
          if (prevTrigger) prevTrigger.setAttribute('aria-expanded', 'false');
          if (prevPanel) prevPanel.hidden = true;
          openItem.classList.remove('is-open');
        }
        trigger.setAttribute('aria-expanded', 'true');
        panel.hidden = false;
        item.classList.add('is-open');
        openItem = item;
        loadCategoryProducts(lookupRoot, item).then(function () {
          if (openItem === item) {
            item.scrollIntoView({
              behavior: prefersReducedMotion() ? 'auto' : 'smooth',
              block: 'nearest'
            });
          }
        });
      });
    });
  }

  function fetchCollectionProducts(handle) {
    var all = [];
    var page = 1;

    function next() {
      return fetch(
        '/collections/' +
          encodeURIComponent(handle) +
          '/products.json?limit=250&page=' +
          page,
        { credentials: 'same-origin', headers: { Accept: 'application/json' } }
      )
        .then(function (res) {
          if (!res.ok) throw new Error('products.json failed');
          return res.json();
        })
        .then(function (data) {
          var batch = (data && data.products) || [];
          all = all.concat(batch);
          if (batch.length === 250) {
            page += 1;
            return next();
          }
          return all;
        });
    }

    return next();
  }

  function resolveAzHandles(lookupRoot) {
    var hub = (lookupRoot.getAttribute('data-cv-az-hub') || '').trim();
    if (hub) return [hub];

    return (lookupRoot.getAttribute('data-cv-az-handles') || '')
      .split(',')
      .map(function (h) {
        return h.trim();
      })
      .filter(Boolean);
  }

  function buildAzCatalog(lookupRoot) {
    var cacheKey = resolveAzHandles(lookupRoot).join(',');
    if (azCatalogCache[cacheKey]) {
      return Promise.resolve(azCatalogCache[cacheKey]);
    }

    var handles = resolveAzHandles(lookupRoot);
    if (!handles.length) {
      azCatalogCache[cacheKey] = [];
      return Promise.resolve([]);
    }

    return Promise.all(
      handles.map(function (handle) {
        return fetchCollectionProducts(handle).catch(function () {
          return [];
        });
      })
    ).then(function (groups) {
      var byId = Object.create(null);
      groups.forEach(function (products) {
        products.forEach(function (product) {
          if (!product || product.id == null) return;
          var id = String(product.id);
          if (byId[id]) return;
          byId[id] = {
            id: id,
            title: product.title || '',
            displayTitle: displayCardTitle(product.title),
            letter: letterFromTitle(product.title),
            url: productUrl(product),
            image: productImageUrl(product),
            available: product.available !== false,
            price: product.price,
            price_min: product.price_min || product.price,
            type: product.product_type || product.type || ''
          };
        });
      });

      var catalog = Object.keys(byId).map(function (id) {
        return byId[id];
      });
      catalog.sort(function (a, b) {
        return String(a.displayTitle || a.title).localeCompare(
          String(b.displayTitle || b.title),
          undefined,
          { sensitivity: 'base', numeric: true }
        );
      });
      azCatalogCache[cacheKey] = catalog;
      return catalog;
    });
  }

  function renderAzCardTile(product) {
    var li = document.createElement('li');
    li.className = 'mc-archive-series-products__cell cab-grid__cell';
    li.setAttribute('data-product-id', product.id);
    li.setAttribute('data-letter', product.letter);

    var a = document.createElement('a');
    a.className =
      'product-card' + (product.available ? '' : ' product-card--sold-out');
    a.href = product.url;

    var media = document.createElement('div');
    media.className = 'product-card__media';
    var cover = document.createElement('div');
    cover.className = 'product-card__cover';
    if (product.image) {
      var img = document.createElement('img');
      img.className = 'product-card__img';
      img.src = product.image;
      img.alt = product.displayTitle || product.title || '';
      img.loading = 'lazy';
      img.decoding = 'async';
      cover.appendChild(img);
    } else {
      var ph = document.createElement('span');
      ph.className = 'product-card__placeholder';
      ph.setAttribute('aria-hidden', 'true');
      cover.appendChild(ph);
    }
    media.appendChild(cover);
    a.appendChild(media);

    var info = document.createElement('div');
    info.className = 'product-card__info';
    var name = document.createElement('p');
    name.className = 'product-card__name';
    name.textContent = product.displayTitle || product.title || 'Card';
    info.appendChild(name);

    var meta = document.createElement('p');
    meta.className = 'product-card__meta';
    if (product.type) {
      var support = document.createElement('span');
      support.className = 'product-card__support';
      support.textContent = product.type;
      meta.appendChild(support);
      var sep = document.createElement('span');
      sep.className = 'product-card__meta-sep';
      sep.setAttribute('aria-hidden', 'true');
      sep.textContent = ' · ';
      meta.appendChild(sep);
    }
    var price = document.createElement('span');
    price.className = 'product-card__price';
    var amount = parseFloat(product.price_min || product.price || 0);
    if (!isNaN(amount)) price.textContent = formatMoney(amount);
    meta.appendChild(price);
    info.appendChild(meta);

    var cta = document.createElement('span');
    cta.className = 'product-card__cta';
    cta.setAttribute('aria-hidden', 'true');
    cta.textContent = 'View';
    info.appendChild(cta);

    a.appendChild(info);
    li.appendChild(a);
    return li;
  }

  function updateAzLetterAvailability(lookupRoot, catalog) {
    var available = Object.create(null);
    catalog.forEach(function (product) {
      available[product.letter] = true;
    });
    lookupRoot.querySelectorAll('[data-archive-letter]').forEach(function (btn) {
      var letter = btn.getAttribute('data-archive-letter');
      if (letter === 'all') {
        btn.disabled = false;
        btn.removeAttribute('aria-disabled');
        return;
      }
      var enabled = !!available[letter];
      btn.disabled = !enabled;
      if (enabled) btn.removeAttribute('aria-disabled');
      else btn.setAttribute('aria-disabled', 'true');
    });
  }

  function filterAzLetter(lookupRoot, letter, options) {
    options = options || {};
    var catalog = lookupRoot._cvAzCatalog || [];
    var grid = lookupRoot.querySelector('[data-cv-az-grid]');
    var status = lookupRoot.querySelector('[data-archive-status]');
    var empty = lookupRoot.querySelector('[data-archive-empty]');
    var loading = lookupRoot.querySelector('[data-cv-az-loading]');
    var error = lookupRoot.querySelector('[data-cv-az-error]');

    if (loading) loading.hidden = true;
    if (error) error.hidden = true;

    lookupRoot.querySelectorAll('[data-archive-letter]').forEach(function (btn) {
      var active = btn.getAttribute('data-archive-letter') === letter;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    var visible = catalog.filter(function (product) {
      return letter === 'all' || product.letter === letter;
    });

    if (grid) {
      grid.innerHTML = '';
      visible.forEach(function (product) {
        grid.appendChild(renderAzCardTile(product));
      });
      grid.hidden = visible.length === 0;
    }

    if (status) {
      if (letter === 'all') {
        status.textContent =
          visible.length === 1 ? '1 card in the vault' : visible.length + ' cards in the vault';
      } else if (letter === '#') {
        status.textContent =
          visible.length === 1
            ? '1 card beginning with a number or symbol'
            : visible.length + ' cards beginning with a number or symbol';
      } else {
        status.textContent =
          visible.length === 1
            ? '1 card beginning with ' + letter
            : visible.length + ' cards beginning with ' + letter;
      }
    }

    if (empty) empty.hidden = visible.length > 0;

    lookupRoot._cvAzLetter = letter;
    if (options.history) {
      writeUrl(
        {
          vault: 'lookup',
          letter: letter === 'all' ? null : letter,
          page: null,
          sort_by: null
        },
        options.history
      );
    }
  }

  function initAz(lookupRoot) {
    if (!lookupRoot || lookupRoot._cvAzBound) return;
    lookupRoot._cvAzBound = true;

    var azRoot = lookupRoot.querySelector('[data-cv-lookup-az]');
    if (!azRoot) return;

    var loading = lookupRoot.querySelector('[data-cv-az-loading]');
    var error = lookupRoot.querySelector('[data-cv-az-error]');
    var retry = lookupRoot.querySelector('[data-cv-az-retry]');
    var status = lookupRoot.querySelector('[data-archive-status]');
    var initialLetter = (getParams().get('letter') || 'all').toUpperCase();
    if (initialLetter !== 'ALL' && initialLetter !== '#') {
      if (!/^[A-Z]$/.test(initialLetter)) initialLetter = 'all';
    } else if (initialLetter === 'ALL') {
      initialLetter = 'all';
    }

    function loadCatalog() {
      if (loading) loading.hidden = false;
      if (error) error.hidden = true;
      if (status) status.textContent = 'Loading cards…';

      return buildAzCatalog(lookupRoot)
        .then(function (catalog) {
          lookupRoot._cvAzCatalog = catalog;
          updateAzLetterAvailability(lookupRoot, catalog);
          if (
            initialLetter !== 'all' &&
            lookupRoot.querySelector(
              '[data-archive-letter="' + initialLetter + '"][disabled]'
            )
          ) {
            initialLetter = 'all';
          }
          filterAzLetter(lookupRoot, initialLetter);
        })
        .catch(function () {
          if (loading) loading.hidden = true;
          if (error) error.hidden = false;
          if (status) status.textContent = 'Cards unavailable';
        });
    }

    lookupRoot.querySelectorAll('[data-archive-letter]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        filterAzLetter(lookupRoot, btn.getAttribute('data-archive-letter') || 'all', {
          history: 'replace'
        });
      });
    });

    if (retry) {
      retry.addEventListener('click', function () {
        var cacheKey = resolveAzHandles(lookupRoot).join(',');
        delete azCatalogCache[cacheKey];
        loadCatalog();
      });
    }

    loadCatalog();
  }

  function formatMoney(amount) {
    var n = parseFloat(amount);
    if (isNaN(n)) return '';
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: 'USD' }).format(n);
    } catch (e) {
      return '$' + n.toFixed(2);
    }
  }

  function initLookupSearch(root, lookupRoot) {
    if (!lookupRoot || lookupRoot._cabSearchBound) return;
    lookupRoot._cabSearchBound = true;
    initCategoryExpand(lookupRoot);
    initAz(lookupRoot);

    var input = lookupRoot.querySelector('[data-cab-lookup-input]');
    var clearBtn = lookupRoot.querySelector('[data-cab-lookup-clear]');
    var live = lookupRoot.querySelector('[data-cab-lookup-live]');
    var results = lookupRoot.querySelector('[data-cab-lookup-results]');
    var resultsList = lookupRoot.querySelector('[data-cab-lookup-results-list]');
    var minChars = parseInt(lookupRoot.getAttribute('data-lookup-min-chars') || '2', 10);
    var emptyText = lookupRoot.getAttribute('data-lookup-empty') || 'No cards matched that search.';
    var debounceTimer = null;
    var abortController = null;
    var savedLetter = 'all';

    function setClearVisible() {
      if (!clearBtn || !input) return;
      clearBtn.hidden = !input.value;
    }

    function clearSearch(options) {
      options = options || {};
      if (input) input.value = '';
      setClearVisible();
      lookupRoot.classList.remove('is-searching');
      if (results) results.hidden = true;
      if (resultsList) resultsList.innerHTML = '';
      if (live) live.textContent = '';
      if (options.history) writeUrl({ vault: 'lookup', q: null }, options.history);
      filterAzLetter(lookupRoot, savedLetter || lookupRoot._cvAzLetter || 'all');
    }

    function renderResults(products) {
      if (!results || !resultsList) return;
      resultsList.innerHTML = '';
      if (!products.length) {
        results.hidden = false;
        resultsList.innerHTML =
          '<li class="cab-empty"><p class="cab-empty__text">' + emptyText + '</p></li>';
        if (live) live.textContent = 'No cards found';
        return;
      }

      products.forEach(function (product) {
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.className = 'cab-lookup__result';
        a.href = product.url;

        if (product.image) {
          var img = document.createElement('img');
          img.className = 'cab-lookup__result-image';
          img.src = product.image;
          img.alt = '';
          img.width = 56;
          img.height = 80;
          img.loading = 'lazy';
          a.appendChild(img);
        } else {
          var ph = document.createElement('span');
          ph.className = 'cab-lookup__result-image cab-lookup__result-image--empty';
          ph.setAttribute('aria-hidden', 'true');
          a.appendChild(ph);
        }

        var copy = document.createElement('div');
        var title = document.createElement('p');
        title.className = 'cab-lookup__result-title';
        title.textContent = product.title || 'Card';
        copy.appendChild(title);
        if (product.type) {
          var meta = document.createElement('p');
          meta.className = 'cab-lookup__result-meta';
          meta.textContent = product.type;
          copy.appendChild(meta);
        }
        a.appendChild(copy);

        var price = document.createElement('span');
        price.className = 'cab-lookup__result-price';
        price.textContent = formatMoney(product.price_min || product.price);
        a.appendChild(price);

        li.appendChild(a);
        resultsList.appendChild(li);
      });

      results.hidden = false;
      if (live) {
        live.textContent = products.length === 1 ? '1 card found' : products.length + ' cards found';
      }
    }

    function runSearch(query, historyMode) {
      if (!query || query.length < minChars) {
        clearSearch({ history: historyMode || false });
        return;
      }

      lookupRoot.classList.add('is-searching');
      var azBtn = lookupRoot.querySelector('[data-archive-letter].is-active');
      if (azBtn) savedLetter = azBtn.getAttribute('data-archive-letter') || 'all';

      if (abortController) abortController.abort();
      abortController = new AbortController();
      if (live) live.textContent = 'Searching…';

      var suggestUrl =
        '/search/suggest.json?q=' +
        encodeURIComponent(query) +
        '&resources[type]=product&resources[limit]=10&resources[options][fields]=title,body,tag,product_type';

      fetch(suggestUrl, {
        signal: abortController.signal,
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Search failed');
          return res.json();
        })
        .then(function (data) {
          var products = (((data || {}).resources || {}).results || {}).products || [];
          var cards = products.filter(function (p) {
            return (p.type || '') === 'Cards';
          });
          renderResults(cards);
          if (historyMode) {
            writeUrl({ vault: 'lookup', q: query, letter: null, page: null, sort_by: null }, historyMode);
          }
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          if (live) live.textContent = 'Search unavailable right now.';
        });
    }

    if (input) {
      input.addEventListener('input', function () {
        setClearVisible();
        window.clearTimeout(debounceTimer);
        var value = input.value.trim();
        debounceTimer = window.setTimeout(function () {
          runSearch(value, 'replace');
        }, 280);
      });
    }

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        clearSearch({ history: 'replace' });
        if (input) input.focus();
      });
    }

    setClearVisible();
    var initialQ = (getParams().get('q') || '').trim();
    if (initialQ && input) {
      input.value = initialQ;
      setClearVisible();
      runSearch(initialQ, false);
    }
  }

  function ensureLookup(root) {
    var panel = root.querySelector('[data-cab-panel][data-cab-view="lookup"]');
    if (!panel) return Promise.resolve();
    var inner = panel.querySelector('[data-cab-panel-inner]');
    if (!inner) return Promise.resolve();

    if (inner.querySelector('[data-cab-lookup]')) {
      initLookupSearch(root, inner.querySelector('[data-cab-lookup]'));
      return Promise.resolve();
    }

    if (lookupCache.markup) {
      inner.innerHTML = lookupCache.markup;
      initLookupSearch(root, inner.querySelector('[data-cab-lookup]'));
      return Promise.resolve();
    }

    if (root._cabLookupAbort) root._cabLookupAbort.abort();
    var controller = new AbortController();
    root._cabLookupAbort = controller;
    showLoading(inner, true);

    var url = new URL(window.location.pathname, window.location.origin);
    url.searchParams.set('view', 'card-vault');
    url.searchParams.set('vault', 'lookup');
    url.searchParams.set('section_id', 'mc-card-vault');

    return fetch(url.toString(), {
      signal: controller.signal,
      credentials: 'same-origin',
      headers: { Accept: 'text/html' }
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Lookup fetch failed');
        return res.text();
      })
      .then(function (html) {
        var markup = extractLookupPanel(html);
        if (!markup) throw new Error('Empty lookup');
        lookupCache.markup = markup;
        inner.innerHTML = markup;
        initLookupSearch(root, inner.querySelector('[data-cab-lookup]'));
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        inner.innerHTML =
          '<div class="cab-empty" role="status"><p class="cab-empty__text">This vault section is currently being catalogued.</p></div>';
      })
      .then(function () {
        if (root._cabLookupAbort === controller) root._cabLookupAbort = null;
      });
  }

  function activateView(root, view, options) {
    options = options || {};
    if (!VALID_VIEWS[view]) view = 'all';

    var current = root.getAttribute('data-cab-active-view') || 'all';
    var browsePanel = root.querySelector('[data-cab-browse-panel]');
    var lookupPanel = root.querySelector('[data-cab-panel][data-cab-view="lookup"]');
    var isLookup = view === 'lookup';
    var wasLookup = current === 'lookup';
    var enableMotion =
      root.classList.contains('cab-archive--transitions') && !prefersReducedMotion();
    var duration = parseInt(root.getAttribute('data-cab-transition-ms') || '280', 10);

    function showNext() {
      if (browsePanel) {
        browsePanel.hidden = isLookup;
        browsePanel.classList.toggle('is-active', !isLookup);
        browsePanel.classList.remove('is-leaving', 'is-entering');
      }
      if (lookupPanel) {
        lookupPanel.hidden = !isLookup;
        lookupPanel.classList.toggle('is-active', isLookup);
        lookupPanel.classList.remove('is-leaving', 'is-entering');
      }

      root.setAttribute('data-cab-active-view', view);
      setTabState(root, view);

      var labelEl = root.querySelector(
        '[data-cab-tab][data-cab-view="' + view + '"] .cab-selector__tab-label'
      );
      announce(root, (labelEl ? labelEl.textContent.trim() : view) + ' view');

      var focusPanel = isLookup ? lookupPanel : browsePanel;
      if (options.focus !== false && focusPanel) {
        focusPanel.setAttribute('tabindex', '-1');
        focusPanel.focus({ preventScroll: true });
      }

      var ready = isLookup ? ensureLookup(root) : ensureProductShelf(root, view);

      return ready.then(function () {
        if (options.history) {
          var params = { vault: view, letter: null };
          if (view !== 'lookup') {
            params.q = null;
            if (!PRODUCT_VIEWS[view]) {
              params.page = null;
              params.sort_by = null;
            }
          } else {
            params.page = null;
            params.sort_by = null;
          }
          writeUrl(params, options.history);
        }
      });
    }

    if (!enableMotion || current === view || (BROWSE_VIEWS[current] && BROWSE_VIEWS[view])) {
      if (current === view || (BROWSE_VIEWS[current] && BROWSE_VIEWS[view] && !wasLookup && !isLookup)) {
        return showNext();
      }
    }

    var leaving = wasLookup ? lookupPanel : browsePanel;
    if (leaving && enableMotion) leaving.classList.add('is-leaving');

    return new Promise(function (resolve) {
      window.setTimeout(
        function () {
          showNext().then(function () {
            var entering = isLookup ? lookupPanel : browsePanel;
            if (entering && enableMotion) {
              entering.classList.add('is-entering');
              window.setTimeout(function () {
                entering.classList.remove('is-entering');
                resolve();
              }, duration);
            } else resolve();
          });
        },
        enableMotion ? Math.min(duration, 300) : 0
      );
    });
  }

  function onTabKeydown(root, event) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-cab-tab]'));
    if (!tabs.length) return;
    var currentIndex = tabs.findIndex(function (tab) {
      return tab.classList.contains('is-active');
    });
    if (currentIndex < 0) currentIndex = 0;
    var nextIndex = currentIndex;
    if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % tabs.length;
    else if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
    else if (event.key === 'Home') nextIndex = 0;
    else if (event.key === 'End') nextIndex = tabs.length - 1;
    else return;
    event.preventDefault();
    var next = tabs[nextIndex];
    next.focus();
    activateView(root, next.getAttribute('data-cab-view'), { history: 'push', focus: false });
  }

  function observeSticky(root) {
    var selector = root.querySelector('[data-cab-selector]');
    if (!selector || !selector.classList.contains('cab-selector--sticky')) return;
    if (!('IntersectionObserver' in window)) return;
    var sentinel = document.createElement('div');
    sentinel.setAttribute('aria-hidden', 'true');
    sentinel.style.cssText = 'position:relative;height:1px;margin:0';
    selector.parentNode.insertBefore(sentinel, selector);
    new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          selector.classList.toggle('is-stuck', !entry.isIntersecting);
        });
      },
      { rootMargin: '-1px 0px 0px 0px', threshold: 0 }
    ).observe(sentinel);
  }

  function initVault(root) {
    if (!root || root._cabBrowserBound) {
      if (root && root._cabBrowserBound) {
        moveIndicator(root);
        updateScrollHint(root);
      }
      return;
    }
    root._cabBrowserBound = true;

    if (root._cabAbort) root._cabAbort.abort();
    var abort = new AbortController();
    root._cabAbort = abort;
    var signal = abort.signal;

    var serverView = root.getAttribute('data-cab-active-view') || 'all';
    var initialView = readView(root);
    observeSticky(root);
    updateScrollHint(root);

    if (initialView !== serverView) {
      activateView(root, initialView, { history: 'replace', focus: false });
    } else {
      setTabState(root, initialView);
      if (initialView === 'lookup') {
        var lookup = root.querySelector('[data-cab-lookup]');
        if (lookup) initLookupSearch(root, lookup);
      } else {
        ensureProductShelf(root, initialView);
      }
    }

    window.addEventListener(
      'resize',
      function () {
        moveIndicator(root);
        updateScrollHint(root);
      },
      { signal: signal, passive: true }
    );

    var track = root.querySelector('[data-cab-tablist]');
    if (track) {
      track.addEventListener('scroll', function () { updateScrollHint(root); }, {
        signal: signal,
        passive: true
      });
      track.addEventListener('keydown', function (event) { onTabKeydown(root, event); }, {
        signal: signal
      });
    }

    root.querySelectorAll('[data-cab-tab]').forEach(function (tab) {
      tab.addEventListener(
        'click',
        function (event) {
          event.preventDefault();
          activateView(root, tab.getAttribute('data-cab-view'), { history: 'push' });
        },
        { signal: signal }
      );
    });

    window.addEventListener(
      'popstate',
      function () {
        activateView(root, readView(root), { history: false, focus: false });
      },
      { signal: signal }
    );

    window.requestAnimationFrame(function () {
      moveIndicator(root);
      scrollActiveTabIntoView(root);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-cv-vault]').forEach(initVault);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target) return;
    var root =
      event.target.querySelector('[data-cv-vault]') ||
      (event.target.hasAttribute && event.target.hasAttribute('data-cv-vault')
        ? event.target
        : null);
    if (!root) return;
    root._cabBrowserBound = false;
    if (root._cabAbort) root._cabAbort.abort();
    initVault(root);
  });
})();
